/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Files_All_FilesInputs */

const en_files_all_files = /** @type {(inputs: Files_All_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All files`)
};

const es_files_all_files = /** @type {(inputs: Files_All_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los archivos`)
};

/**
* | output |
* | --- |
* | "All files" |
*
* @param {Files_All_FilesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const files_all_files = /** @type {((inputs?: Files_All_FilesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Files_All_FilesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_files_all_files(inputs)
	return en_files_all_files(inputs)
});